// Lightweight, dependency-free profanity guard for student-facing text inputs.
// Blocks obvious profanity/slurs (incl. simple spacing + leetspeak evasion) while
// keeping false positives low (word-boundary match for short words).

const BLOCKLIST = [
  "fuck", "shit", "bitch", "bastard", "asshole", "dick", "piss", "crap",
  "cunt", "damn", "prick", "slut", "whore", "wank", "bollock", "bugger",
  "nigger", "nigga", "faggot", "fag", "retard", "spastic", "twat",
  "sex", "porn", "penis", "vagina", "boob", "tit", "arse", "ass",
];

function leetNormalize(s) {
  return s
    .toLowerCase()
    .replace(/@/g, "a")
    .replace(/\$/g, "s")
    .replace(/0/g, "o")
    .replace(/1/g, "i")
    .replace(/3/g, "e")
    .replace(/4/g, "a")
    .replace(/5/g, "s")
    .replace(/7/g, "t");
}

export function containsProfanity(text) {
  if (!text) return false;
  const norm = leetNormalize(String(text));
  const collapsed = norm.replace(/[^a-z]/g, "");
  return BLOCKLIST.some((w) => {
    const re = new RegExp(`\\b${w}\\b`, "i");
    if (re.test(norm)) return true;
    // catch spaced-out evasion like "f u c k" only for longer words
    if (w.length >= 4 && collapsed.includes(w)) return true;
    return false;
  });
}
